import { GridColumnType } from "../../../data/gridColumnType";

export const PositionSubSkillListGridConfig = {
    columns: [
        {
            name: "Sub Skill Name",
            fieldName: "subSkillName",
            allowShort: false,
        },
        // {
        //   name : "Description",
        //   fieldName : "description",
        //   allowShort: false,
        // },
        {
            name: "Is Sub Skill Required",
            fieldName: "isSubSkillRequired",
            colType: GridColumnType.CHECKBOX,
            allowShort: false,
            colSettings: {
                allowEdit: true,
              },
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
              allowEdit: false,
              allowDelete: true
            }
          },
    ],
}